import enUS from './enUS'

const enAU = {
  ...enUS
}

export default enAU
